// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessconflict/v1/accessconflict.proto" (package "c1.api.accessconflict.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchRequest
 */
export interface ConflictMonitorSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitorRef refs = 3;
     */
    refs: ConflictMonitorRef[];
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchResponse
 */
export interface ConflictMonitorSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitor list = 1;
     */
    list: ConflictMonitor[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsRequest
 */
export interface ConflictMonitorSearchWithCountsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitorRef refs = 3;
     */
    refs: ConflictMonitorRef[];
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsResponse
 */
export interface ConflictMonitorSearchWithCountsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitorView list = 1;
     */
    list: ConflictMonitorView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorGetRequest
 */
export interface ConflictMonitorGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorDeleteRequest
 */
export interface ConflictMonitorDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorDeleteResponse
 */
export interface ConflictMonitorDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorListRequest
 */
export interface ConflictMonitorListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorListWithCountsRequest
 */
export interface ConflictMonitorListWithCountsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorView
 */
export interface ConflictMonitorView {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.ConflictMonitor monitor = 1;
     */
    monitor?: ConflictMonitor;
    /**
     * @generated from protobuf field: int64 violation_count = 2;
     */
    violationCount: number;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorListResponse
 */
export interface ConflictMonitorListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitor list = 1;
     */
    list: ConflictMonitor[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorListWithCountsResponse
 */
export interface ConflictMonitorListWithCountsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitorView list = 1;
     */
    list: ConflictMonitorView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorCreateRequest
 */
export interface ConflictMonitorCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.NotificationConfig notification_config = 3;
     */
    notificationConfig?: NotificationConfig;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorUpdateRequest
 */
export interface ConflictMonitorUpdateRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.NotificationConfig notification_config = 4;
     */
    notificationConfig?: NotificationConfig;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorEnableRequest
 */
export interface ConflictMonitorEnableRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: bool enabled = 2;
     */
    enabled: boolean;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorForceRunRequest
 */
export interface ConflictMonitorForceRunRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.SlackNotifications
 */
export interface SlackNotifications {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string channel_name = 2;
     */
    channelName: string;
    /**
     * @generated from protobuf field: string channel_id = 3;
     */
    channelId: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.EmailNotifications
 */
export interface EmailNotifications {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated string identity_user_ids = 2;
     */
    identityUserIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.NotificationConfig
 */
export interface NotificationConfig {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EmailNotifications email_notifications = 1;
     */
    emailNotifications?: EmailNotifications;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.SlackNotifications slack_notifications = 2;
     */
    slackNotifications?: SlackNotifications;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitor
 */
export interface ConflictMonitor {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string entitlement_set_a_id = 4;
     */
    entitlementSetAId: string;
    /**
     * @generated from protobuf field: string entitlement_set_b_id = 5;
     */
    entitlementSetBId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool enabled = 9;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.NotificationConfig notification_config = 10;
     */
    notificationConfig?: NotificationConfig;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorRef
 */
export interface ConflictMonitorRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorSearchRequest$Type extends MessageType<ConflictMonitorSearchRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitorRef },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchRequest
 */
export const ConflictMonitorSearchRequest = new ConflictMonitorSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorSearchResponse$Type extends MessageType<ConflictMonitorSearchResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitor },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchResponse
 */
export const ConflictMonitorSearchResponse = new ConflictMonitorSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorSearchWithCountsRequest$Type extends MessageType<ConflictMonitorSearchWithCountsRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitorRef },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsRequest
 */
export const ConflictMonitorSearchWithCountsRequest = new ConflictMonitorSearchWithCountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorSearchWithCountsResponse$Type extends MessageType<ConflictMonitorSearchWithCountsResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitorView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsResponse
 */
export const ConflictMonitorSearchWithCountsResponse = new ConflictMonitorSearchWithCountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorGetRequest$Type extends MessageType<ConflictMonitorGetRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorGetRequest
 */
export const ConflictMonitorGetRequest = new ConflictMonitorGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorDeleteRequest$Type extends MessageType<ConflictMonitorDeleteRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorDeleteRequest
 */
export const ConflictMonitorDeleteRequest = new ConflictMonitorDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorDeleteResponse$Type extends MessageType<ConflictMonitorDeleteResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorDeleteResponse
 */
export const ConflictMonitorDeleteResponse = new ConflictMonitorDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorListRequest$Type extends MessageType<ConflictMonitorListRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorListRequest
 */
export const ConflictMonitorListRequest = new ConflictMonitorListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorListWithCountsRequest$Type extends MessageType<ConflictMonitorListWithCountsRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorListWithCountsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorListWithCountsRequest
 */
export const ConflictMonitorListWithCountsRequest = new ConflictMonitorListWithCountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorView$Type extends MessageType<ConflictMonitorView> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorView", [
            { no: 1, name: "monitor", kind: "message", T: () => ConflictMonitor },
            { no: 2, name: "violation_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorView
 */
export const ConflictMonitorView = new ConflictMonitorView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorListResponse$Type extends MessageType<ConflictMonitorListResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitor },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorListResponse
 */
export const ConflictMonitorListResponse = new ConflictMonitorListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorListWithCountsResponse$Type extends MessageType<ConflictMonitorListWithCountsResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorListWithCountsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitorView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorListWithCountsResponse
 */
export const ConflictMonitorListWithCountsResponse = new ConflictMonitorListWithCountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorCreateRequest$Type extends MessageType<ConflictMonitorCreateRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "notification_config", kind: "message", T: () => NotificationConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorCreateRequest
 */
export const ConflictMonitorCreateRequest = new ConflictMonitorCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorUpdateRequest$Type extends MessageType<ConflictMonitorUpdateRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorUpdateRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "notification_config", kind: "message", T: () => NotificationConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorUpdateRequest
 */
export const ConflictMonitorUpdateRequest = new ConflictMonitorUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorEnableRequest$Type extends MessageType<ConflictMonitorEnableRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorEnableRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorEnableRequest
 */
export const ConflictMonitorEnableRequest = new ConflictMonitorEnableRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorForceRunRequest$Type extends MessageType<ConflictMonitorForceRunRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorForceRunRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorForceRunRequest
 */
export const ConflictMonitorForceRunRequest = new ConflictMonitorForceRunRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SlackNotifications$Type extends MessageType<SlackNotifications> {
    constructor() {
        super("c1.api.accessconflict.v1.SlackNotifications", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "channel_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "channel_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.SlackNotifications
 */
export const SlackNotifications = new SlackNotifications$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailNotifications$Type extends MessageType<EmailNotifications> {
    constructor() {
        super("c1.api.accessconflict.v1.EmailNotifications", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "identity_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.EmailNotifications
 */
export const EmailNotifications = new EmailNotifications$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationConfig$Type extends MessageType<NotificationConfig> {
    constructor() {
        super("c1.api.accessconflict.v1.NotificationConfig", [
            { no: 1, name: "email_notifications", kind: "message", T: () => EmailNotifications },
            { no: 2, name: "slack_notifications", kind: "message", T: () => SlackNotifications }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.NotificationConfig
 */
export const NotificationConfig = new NotificationConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitor$Type extends MessageType<ConflictMonitor> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitor", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 4, name: "entitlement_set_a_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 5, name: "entitlement_set_b_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "notification_config", kind: "message", T: () => NotificationConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitor
 */
export const ConflictMonitor = new ConflictMonitor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorRef$Type extends MessageType<ConflictMonitorRef> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorRef
 */
export const ConflictMonitorRef = new ConflictMonitorRef$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AccessConflictService
 */
export const AccessConflictService = new ServiceType("c1.api.accessconflict.v1.AccessConflictService", [
    { name: "ListMonitor", options: { "authz.method": { role: "VIEWER" } }, I: ConflictMonitorListRequest, O: ConflictMonitorListResponse },
    { name: "ListMonitorWithCounts", options: { "authz.method": { role: "VIEWER" } }, I: ConflictMonitorListWithCountsRequest, O: ConflictMonitorListWithCountsResponse },
    { name: "GetMonitor", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/accessconflict/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access_Conflict", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Access Conflict" }] } }, I: ConflictMonitorGetRequest, O: ConflictMonitor },
    { name: "CreateMonitor", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/accessconflict", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access_Conflict" }], group: "Access Conflict" }] } }, I: ConflictMonitorCreateRequest, O: ConflictMonitor },
    { name: "DeleteMonitor", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/accessconflict/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access_Conflict" }], group: "Access Conflict" }] } }, I: ConflictMonitorDeleteRequest, O: ConflictMonitorDeleteResponse },
    { name: "UpdateMonitor", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/accessconflict/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Access_Conflict" }], group: "Access Conflict" }] } }, I: ConflictMonitorUpdateRequest, O: ConflictMonitor },
    { name: "EnableMonitor", options: { "authz.method": { role: "EDITOR" } }, I: ConflictMonitorEnableRequest, O: ConflictMonitor },
    { name: "ForceRunMonitor", options: { "authz.method": { role: "EDITOR" } }, I: ConflictMonitorForceRunRequest, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AccessConflictSearchService
 */
export const AccessConflictSearchService = new ServiceType("c1.api.accessconflict.v1.AccessConflictSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: ConflictMonitorSearchRequest, O: ConflictMonitorSearchResponse },
    { name: "SearchWithCounts", options: { "authz.method": { role: "VIEWER" } }, I: ConflictMonitorSearchWithCountsRequest, O: ConflictMonitorSearchWithCountsResponse }
]);
